// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge-select[data-v-3fa6c0b4]{cursor:pointer}.badge-circle-select[data-v-3fa6c0b4]{width:2rem !important;line-height:2.1 !important}.low-opacity[data-v-3fa6c0b4]{opacity:60%}", ""]);
// Exports
module.exports = exports;
